import * as React from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'
import PropTypes from 'prop-types'
import { cn } from '../../utils/lib/utils'

const Slider = React.forwardRef(function Slider({ 
  className, 
  label,
  value,
  defaultValue,
  min,
  max,
  step,
  disabled,
  orientation = 'horizontal',
  ...props 
}, ref) {
  return (
    <div className="space-y-2">
      {label && <div className="text-sm font-medium">{label}</div>}
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          'relative flex w-full touch-none select-none items-center',
          orientation === 'horizontal' ? 'h-5' : 'h-full flex-col',
          className
        )}
        orientation={orientation}
        {...props}
      >
        <SliderPrimitive.Track
          className={cn(
            'relative grow rounded-full bg-slate-100',
            orientation === 'horizontal' ? 'h-2' : 'w-2'
          )}
        >
          <SliderPrimitive.Range className="absolute h-full rounded-full bg-slate-900" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className="block h-4 w-4 rounded-full border border-slate-200 border-slate-900/50 bg-white ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        />
      </SliderPrimitive.Root>
    </div>
  )
})

Slider.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  defaultValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
}

Slider.displayName = 'Slider'

export { Slider }
